import { ITester } from '@/store/interfaces/tester';

export const createTester = (): ITester => ({
  test: async (deviceId: string) => {
    throw new Error(`Function not implemented.${deviceId}`);
  },
});
